import { TorpedoItem, TorpedoLayoutConfig, TorpedoProps } from '../types';
import {
  WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL,
  WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE,
  WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE,
  WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT,
} from '../../DeviationViews/constants';
import { WithMobileContextProps } from '@wix/da-react-context/pkg/MobileContext';

// Make massive images smaller, if the image is massive in ratio
// we simply crop it to 16/9, this creates a "fair" showing look
export const applyMassiveThumbThreshold = (item: TorpedoItem) => {
  const whRatio = item.width / item.height;
  // too tall
  if (whRatio < WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL) {
    item.height = item.width / WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT;
  }
  // too wide
  if (whRatio > WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE) {
    item.width = item.height * WIDTH_TO_HEIGHT_RATIO_DEFAULT_LANDSCAPE;
  }
  return item;
};

export const applyTinyThumbThreshold = (
  item: TorpedoItem,
  targetHeight: number
) => {
  const tinyThumbWidthThreshold: number =
    targetHeight * WIDTH_TO_HEIGHT_RATIO_DEFAULT_PORTRAIT;
  const tinyThumbHeightThreshold: number = targetHeight;
  item.width = Math.max(tinyThumbWidthThreshold, item.width);
  item.height = Math.max(tinyThumbHeightThreshold, item.height);
  return item;
};

export function getRowSize(
  layoutConfig: TorpedoLayoutConfig,
  isMobile: boolean,
  useCardLayout?: boolean
) {
  if (useCardLayout) {
    return isMobile
      ? layoutConfig.rowSizeCardMobile
      : layoutConfig.rowSizeCardDesktop;
  }

  return isMobile ? layoutConfig.rowSizeMobile : layoutConfig.rowSizeDesktop;
}

export function getItemSpacing(
  layoutConfig: TorpedoLayoutConfig,
  isMobile: boolean,
  useCardLayout?: boolean
) {
  if (
    layoutConfig.itemSpacingDesktop === 0 ||
    layoutConfig.itemSpacingMobile === 0
  ) {
    return 0;
  }

  if (useCardLayout) {
    return isMobile
      ? (layoutConfig.itemSpacingCardMobile || 8) / 2
      : (layoutConfig.itemSpacingCardDesktop || 16) / 2;
  }

  return isMobile
    ? (layoutConfig.itemSpacingMobile || 8) / 2
    : (layoutConfig.itemSpacingDesktop || 16) / 2;
}

export const didItemsChange = (itemsA, itemsB) => {
  if (itemsA && itemsA.length !== itemsB.length) {
    return true;
  }

  const total = (itemsA && itemsA.length) || 0;
  for (let i = 0; i < total; i++) {
    if (
      itemsA![i].id !== itemsB[i].id ||
      itemsA![i].width !== itemsB[i].width ||
      itemsA![i].height !== itemsB[i].height
    ) {
      return true;
    }
  }
  return false;
};

export const propsItemsOrContainerHasChanged = (
  nextProps: TorpedoProps & WithMobileContextProps,
  prevProps: Partial<TorpedoProps>
): boolean => {
  if (!prevProps || !prevProps.container || !nextProps) {
    return true;
  }
  const {
    items: nextItems = [],
    container: { width: nextContainerWidth },
  } = nextProps;
  const {
    items: prevItems = [],
    container: { width: prevContainerWidth },
  } = prevProps;

  const dimChanged = prevContainerWidth !== nextContainerWidth;
  const itemChanged = didItemsChange(prevItems, nextItems);

  if (dimChanged || itemChanged) {
    return true;
  }

  return false;
};
